import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: BASE_URL,
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mv_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mv_token');
      localStorage.removeItem('mv_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

/**
 * Raw fetch() wrapper that prepends REACT_APP_API_URL so watermarked-image
 * and download endpoints work on Netlify (where there is no dev proxy).
 * Mirrors the axios instance: attaches the JWT when a token is present.
 */
export function apiFetch(path, options = {}) {
  const token = localStorage.getItem('mv_token');
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  return fetch(`${BASE_URL}${path}`, { ...options, headers });
}

export default api;
